module.exports = "<div class=\"popup-container\">\r\n  <div class=\"popup-wrapper\" (click)=\"close()\"></div>\r\n  <div class=\"popup\">\r\n    <a class=\"close\" (click)=\"close()\">&times;</a>\r\n    <h5>Welcome to the new Linescape!</h5>\r\n    <p>Please contact us with your thoughts and feedback.</p>\r\n    <div class=\"col-holder\">\r\n      <a class=\"btn mt15\" style=\"margin-right: 3px;\" [routerLink]=\"['/contact']\" (click)=\"close()\">Submit Feedback</a>\r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/message/arrival-message/arrival-message.component.html
// module id = 920
// module chunks = 0